import {clearSsoCookie, getSsoUrl} from 'frontend/utils/auth_helpers';

/**
 * Logs the user out of the session and redirects to the SSO login page.
 *
 * Clears sessionStorage, deletes the SSO session token cookie, and navigates
 * to the SSO application login route with logout=true.
 */
export function performLogout() {
  sessionStorage.clear();

  let currentUrl: URL;
  try {
    currentUrl = new URL(window.location.href);
  } catch {
    currentUrl = new URL('http://localhost');
  }

  clearSsoCookie();

  const redirectUrl = getSsoUrl(currentUrl.toString(), {logout: true});

  window.location.href = redirectUrl;
}
